import { Button } from "components/Buttons";
import { ButtonColorScheme, ButtonType } from "types/ui";
import { Grid } from "@mui/material";
import { ManagementType } from "types/common";
import { userOperations, USER_GROUPS } from "constants/roles";
import { SearchBox } from "components/SearchBox/SearchBox";
import { FilterModal } from "components/FilterModal/FilterModal";
import { FilterType } from "constants/types";
import CustomizedMenu from "../../../../../components/CustomizedMenu/CustomizedMenu";
import { PAGES } from "../../../../../constants/pages";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/reduxHooks";
import {
  selectClinicRecoveryTemplates,
  selectCurrentRecoveryTemplate,
} from "../../../../../store/ClinicianStore/selectors";
import * as React from "react";
import {
  removeRecoveryTemplate,
  setSelectedRecoveryTemplate,
} from "../../../../../store/ClinicianStore/clinicianSlice";
import { RemoveNoteModal } from "../../../../VideoReview/components/RemoveNoteModal";
import { ClinicRepository } from "../../../../../repositories/ClinicRepository";
import { getRouteLink } from "../../../../../utils/general";
import { useHistory } from "react-router-dom";

type HeaderActionsByTabProps = {
  managementType?: ManagementType;
  openCreateEditModalWithOperation: any;
  setOpenFilterModal: any;
  currentClinician: any;
  openFilterModal: any;
  setOpenInviteModal: any;
};

const HeaderActionsByTab = ({
  managementType,
  openCreateEditModalWithOperation,
  currentClinician,
  openFilterModal,
  setOpenInviteModal,
  setOpenFilterModal,
}: HeaderActionsByTabProps) => {
  const dispatch = useAppDispatch();
  const [isRemoveModalVisible, setIsRemoveModalVisible] = React.useState(false);
  const [removeTemplateLoading, setRemoveTemplateLoading] =
    React.useState(false);
  const currentRecoveryTemplates: string[] | undefined = useAppSelector(
    selectClinicRecoveryTemplates
  );
  const selectedRecoveryTemplate: any = useAppSelector(
    selectCurrentRecoveryTemplate
  );
  const history = useHistory();

  const onEditTemplateClick = (templateId: string) => {
    const selectedTemplate: any = currentRecoveryTemplates?.find(
      (element: any) => element._id === templateId
    );
    history.push(`${getRouteLink(PAGES.editTemplate)}${selectedTemplate?._id}`);
  };

  const onDeleteClick = (templateId: string) => {
    setIsRemoveModalVisible(true);
    const selectedTemplate = currentRecoveryTemplates?.find(
      (element: any) => element._id === templateId
    );
    dispatch(setSelectedRecoveryTemplate(selectedTemplate));
  };
  const onConfirmDeleteNote = async () => {
    setRemoveTemplateLoading(true);
    const clinicianRepository = ClinicRepository.getInstance();
    await clinicianRepository
      .deleteRecoveryTemplate(selectedRecoveryTemplate._id)
      .then(
        () => (
          setIsRemoveModalVisible(false),
          setRemoveTemplateLoading(false),
          dispatch(removeRecoveryTemplate(selectedRecoveryTemplate._id))
        )
      );
    dispatch(setSelectedRecoveryTemplate([]));
  };

  const recoveryTemplates =
    currentRecoveryTemplates?.map((item: any) => ({
      text: item.name,
      hasDivider: false,
      hasEditButton: true,
      page: PAGES.createTemplate,
      hasDeleteButton: true,
      id: item._id,
    })) ?? [];

  const menuOptions = [
    {
      page: PAGES.createTemplate,
      text: "Create New Template",
      hasDivider: true,
      hasEditButton: false,
      hasDeleteButton: false,
    },
    ...recoveryTemplates,
  ];

  return (
    <>
      {managementType == ManagementType.USER && (
        <Button
          title="Create New User"
          onClick={() => {
            openCreateEditModalWithOperation(true, userOperations.CREATE);
          }}
          type={ButtonType.normal}
          colorScheme={ButtonColorScheme.gradient}
        />
      )}
      {currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT) &&
        managementType == ManagementType.PATIENT && (
          <>
            <Button
              title="Invite Patient"
              onClick={() => {
                setOpenInviteModal(true);
              }}
              type={ButtonType.normal}
              colorScheme={ButtonColorScheme.gradient}
            />
            <FilterModal
              isEnabled={openFilterModal}
              setIsEnabled={setOpenFilterModal}
              operation={FilterType.PATIENT_FILTER}
              currentClinician={currentClinician}
            />
          </>
        )}
      {currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD) &&
        managementType == ManagementType.PATIENT && (
          <CustomizedMenu
            buttonText={"Recovery plan Templates"}
            options={menuOptions}
            onEditClick={onEditTemplateClick}
            onDeleteClick={onDeleteClick}
          />
        )}

      <Grid justifyContent="flex-end">
        <SearchBox isAthlete={false} managementType={managementType} />
      </Grid>
      {
        <RemoveNoteModal
          showModal={isRemoveModalVisible}
          headerText={"Delete Template"}
          bodyText={
            "Are you sure you want to delete this Template? If you confirm, this note will be deleted permanently."
          }
          loading={removeTemplateLoading}
          onClose={() => setIsRemoveModalVisible(false)}
          onConfirm={() => onConfirmDeleteNote()}
        />
      }
    </>
  );
};

export default HeaderActionsByTab;
